import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
// Eigene Imports
import { baseUrl } from "../../../helpers/constants";
import { IUserProductMigrationRequestDto } from "../../../Models/IUserProductmigrationRequestDto";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  Button,
  createTableColumn,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { ArrowCircleUpRegular } from "@fluentui/react-icons";
import Header from "../../Layout/Header";

function OvertakeProductRequests(props: any) {
  const [requests, setRequests] = useState([]);

  const getRequests = () => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/vertrieb/GetAllOvertakeProductRequests")
      .then((data) => {
        setRequests(data);
      });
  };
  const columns: TableColumnDefinition<IUserProductMigrationRequestDto>[] = [
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "seriennNummerId",
      compare: (a, b) => {
        if (a.userProdukt.seriennummer && b.userProdukt.seriennummer) {
          return a.userProdukt.seriennummer.localeCompare(
            b.userProdukt.seriennummer,
          );
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("productId");
      },
      renderCell: (item) => {
        return item.userProdukt.seriennummer;
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "bennenungId",
      compare: (a, b) => {
        if (i18n.language.includes("de")) {
          return a.userProdukt.benennungDE.localeCompare(
            b.userProdukt.benennungDE,
          );
        } else
          return a.userProdukt.benennungEN.localeCompare(
            b.userProdukt.benennungEN,
          );
      },
      renderHeaderCell: () => {
        return i18n.t<string>("benennung");
      },
      renderCell: (item) => {
        return i18n.language.includes("de")
          ? item.userProdukt?.benennungDE
          : item.userProdukt?.benennungEN;
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "anfragerId",
      compare: (a, b) => {
        if (a.requester.fullName && b.requester.fullName) {
          return a.requester.fullName.localeCompare(b.requester.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("anfrager");
      },
      renderCell: (item) => {
        return item.requester.fullName;
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "besitzerId",
      compare: (a, b) => {
        if (a.owner.fullName && b.owner.fullName) {
          return a.owner.fullName.localeCompare(b.owner.fullName);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("besitzer");
      },
      renderCell: (item) => {
        return item.owner.fullName;
      },
    }),
    createTableColumn<IUserProductMigrationRequestDto>({
      columnId: "createDateId",
      compare: (a, b) => {
        if (a.createdOn && b.createdOn) {
          return a.createdOn.localeCompare(b.createdOn);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("erstelltAm");
      },
      renderCell: (item) => {
        return new Date(item.createdOn).toLocaleString();
      },
    }),
  ];
  useEffect(() => {
    getRequests();
  }, []);

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<ArrowCircleUpRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("overtakeProductRequests").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <div className="lueb-Padding20">
          <LuebPagedDataGrid
            columns={columns}
            items={requests}
            resizableColumns={true}
            columnSizingOptions={{
              SerienNummerId: { defaultWidth: 200, minWidth: 150 },
              benennungId: { defaultWidth: 250, minWidth: 200 },
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default OvertakeProductRequests;
